import * as React from 'react';
import mosaicGuardians from '../../image/mosaicGuardians.png';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import IconButton from '@mui/material/IconButton'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import MenuButton from './MenuButton';
import SelectContent from './SelectContent';
import MenuContent from './MenuContent';
import CardAlert from './CardAlert';
import DrawerHeader from './DrawerHeader';
import BrandName from './BrandName';
import OptionsMenu from './OptionsMenu';
import { styled } from '@mui/material/styles';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';

const Drawer = styled(MuiDrawer)(
  ({ theme, visible }) => ({
    opacity: visible,
    transition: theme.transitions.create([ 'width', 'opacity' ], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    })
  }),
);

function SideMenuMobile({ open, handleAuthAction, handleDrawerClose, handleDrawerToggle, sendAuthSkill, visible, currentUser }) {
  return (
    <Drawer
      anchor="left"
      open={open}
      // visible={visible}
      // onClick={handleDrawerClose}
      sx={{[`& .${drawerClasses.paper}`]: {
        backgroundImage: 'none',
        backgroundColor: 'rgba(28, 28, 28, 0.1)',
        backdropFilter: 'blur(10px)',
        overflowX: 'hidden'
      },}}
      PaperProps={{
          style: {
            width: '300px',
          }
      }}
    >
      <DrawerHeader >
        <BrandName open={open} >
        {currentUser && <Stack direction="row"
            sx={{
              p: 2,
              gap: 2,
              alignItems: 'center',
              borderTop: '1px solid',
              borderColor: 'divider',
            }}>
            <Avatar
              sizes="small"
              src={mosaicGuardians}
              sx={{ width: 40, height: 40}}
            />
            MOSAIC GUARDIANS
          </Stack> }
        </BrandName>
        <IconButton onClick={handleDrawerToggle} sx={{ color: 'white' }}>
          <ChevronLeftIcon />
          </IconButton>
      </DrawerHeader>
      {currentUser && <Stack direction="row"
          sx={{
            p: 2,
            gap: 2,
            alignItems: 'center',
            borderTop: '1px solid',
            borderColor: 'divider',
            marginLeft: '',
          }}>
          <Avatar
            onClick={handleDrawerToggle}
            sizes="small"
            alt={currentUser.nick_name}
            src="/static/images/avatar/7.jpg"
            sx={{ width: 40, height: 40 }}
          />
          <Box sx={{ mr: 'auto' }}>
          <Typography variant="body2" sx={{ color: 'white', fontWeight: 500, lineHeight: '16px' }}>
          {currentUser.nick_name}
          </Typography>
          <Typography variant="caption" sx={{ color: 'white' }}>
            {currentUser.email}
          </Typography>
          </Box>
          <OptionsMenu open={open} close={handleDrawerClose} />
        </Stack>}
        
      {/* <Box
        sx={{
          display: 'flex',
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 1.5,
        }}
      >
        <SelectContent />
      </Box> */}
      <Divider />
      <MenuContent open={open} handleDrawerClose={handleDrawerClose} />
      <Stack
        sx={{
          height: 'auto',
        }}
      ></Stack>
      {/* <CardAlert open={open} /> */}
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};

export default SideMenuMobile;
